import { onCLS, onFCP, onINP, onLCP, onTTFB } from "web-vitals"

const enviarMetrica = ({ name, value, id, rating }) => {
  if (process.env.NODE_ENV !== "production") {
    // eslint-disable-next-line no-console
    console.info(`[WebVitals] ${name}:`, Math.round(value), rating, id)
    return
  }

  const oPayload = JSON.stringify({ name, value, id, rating, rota: window.location.pathname })
  if (navigator.sendBeacon) {
    navigator.sendBeacon("/api/metricas/web-vitals", oPayload)
  }
}

export const iniciarMonitoramentoWebVitals = () => {
  onCLS(enviarMetrica)
  onFCP(enviarMetrica)
  onLCP(enviarMetrica)
  onINP(enviarMetrica)
  onTTFB(enviarMetrica)
}
